// A coach's Clear on a client in "Needs you" (plan 004, migration 079). Only the client's own active
// coach, or an active super admin, can read or make one; the database sets who and when.
import { supabase } from '../supabase';

// The newest Clear for each client. Clears are few (one per tap), so the recent ones are read and
// the first per client kept; ordered newest first, with the id as the tie-breaker.
export const getLatestClears = async (clientIds) => {
  if (!clientIds || clientIds.length === 0) return {};
  const { data, error } = await supabase
    .from('coach_attention_clears')
    .select('id, client_id, cleared_by, cleared_at, seen_message_at, seen_check_in_at, seen_flag_at')
    .in('client_id', clientIds)
    .order('cleared_at', { ascending: false })
    .order('id', { ascending: false })
    .limit(2000);
  if (error) throw error;
  const latest = {};
  (data || []).forEach((row) => { if (!latest[row.client_id]) latest[row.client_id] = row; });
  return latest;
};

// Clear a client: `seen` is what their card showed (seenForClear). Returns the new row; a refused or
// failed write throws, so the card is not hidden on a guess.
export const clearAttention = async (clientId, seen = {}) => {
  const { data, error } = await supabase
    .from('coach_attention_clears')
    .insert({ client_id: clientId, ...seen })
    .select('id, client_id, cleared_by, cleared_at, seen_message_at, seen_check_in_at, seen_flag_at')
    .single();
  if (error) throw error;
  if (!data) throw new Error('The clear was not saved');
  return data;
};

// Undo one's own Clear (allowed for 10 minutes). Throws if nothing was removed.
export const undoClear = async (clearId) => {
  const { data, error } = await supabase
    .from('coach_attention_clears')
    .delete()
    .eq('id', clearId)
    .select('id');
  if (error) throw error;
  if (!data || data.length === 0) throw new Error('Too late to undo, or not yours to undo');
  return true;
};
